<div class="position-relative z-3" (clickOutside)="hideContent()">
  <a
    type="button"
    class="app-selection-trigger d-flex justify-content-center p-2 pt-0 position-relative"
    (click)="toggleContent()"
    placement="start"
    ngbTooltip="Open app selection"
    tooltipClass="custom-tooltip"
    [openDelay]="1000"
    data-cy="app-selection"
  >
    <span class="rb-ic rb-ic-grid-view fs-2xl hover-effect"></span>
  </a>
  @if (isContentVisible) {
    <div class="app-selection-panel p-3 rounded-2 position-absolute end-0 border">
      <div class="app-selection-cell" *hasPermissionAny="[Permissions.VZO_Apps_Internal]">
        <a
          class="app-selection-item d-flex flex-column align-items-center justify-content-center ho-menu-item p-2 rounded-2 text-reset"
          [class.sel-menu-item]="isInternalEnabled"
          [routerLink]="isInternalEnabled ? undefined : '/internal'"
          data-cy="internalView"
        >
          <span class="rb-ic rb-ic-speedlimit-revoking fs-2xl"></span>
          <span class="fs-xs text-center text-decoration-none">Internal</span>
        </a>
      </div>
      <div class="app-selection-cell" *hasPermissionAny="[Permissions.VZO_Apps_Customer]">
        <a
          class="app-selection-item d-flex flex-column align-items-center justify-content-center ho-menu-item p-2 rounded-2 text-reset"
          [class.sel-menu-item]="isCustomerViewEnabled"
          [routerLink]="isCustomerViewEnabled ? undefined : '/customer'"
          data-cy="customerView"
        >
          <span class="rb-ic rb-ic-customer fs-2xl"></span>
          <span class="fs-xs text-center text-decoration-none">Customer</span>
        </a>
      </div>
    </div>
  }
</div>
